import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { ArrowBigDown } from "lucide-react";
import SignPopup from "../../../popup/signaturePopup";
import Breadcrumbs from "../../../reusebale/breadcrumbs";
import ButtonTag from "../../../reusebale/button";
import ImageTag from "../../../reusebale/imageTag";
import Myloader from "../../../reusebale/myLoader";
import ParagraphTag from "../../../reusebale/Paragraph";
import LeaseLoader from "../../../skeleton-loader/lease-detail";
import Agreement from "../../../template/flexIndustrialLeaseAgreementSample";
import Chat from "./chat";
import CompanyInfo from "./company-info";
import LandlordInfo from "./landrlordInfo";
import MaintainRequestSection from "./maintainance-request";
import PropertyInfo from "./propertyInfo";
import ReceivePayment from "./receivePayment";
import RentBreakDown from "./rentBreakDown";
import RentScheduleTable from "./rentScheduleTable";
import TenantInfo from "./tenantInfo";
import TerminationReason from "./terminationReason";
import TransactionsTable from "../../home/transactionsTable";

import BaseUrl from "../../../../constants/BaseUrl";
import { ShowSuccess, ShowError } from "../../../../utils/ToasFunction";
// import db from "../../../../db/index.json";

const DetailLeaseMain = ({
  onBack,
  showDetailStatus,
  recordId,
  onViewDetailsMaintain,
  onMaintainancePage,
  toggleTennatTable,
  onTriggerCard,
}) => {
  // const { lease } = db;

  const [leaseDetails, setLeaseDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tenantInfo, setTenantInfo] = useState();
  const [showTransactions, setShowTransactions] = useState(false);
  const { loginSuccess } = useSelector((state) => state.auth);

  const GetTenantProfile = useCallback(
    (id) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}tenant/profile/getProfileDetails/${id}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "Success") {
            setTenantInfo(result.data);
          }
        })
        .catch((error) => console.error(error));
    },
    [loginSuccess?.token]
  );

  const GetLandlordProfile = useCallback(
    (id) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        `${BaseUrl}landlord/profile/getProfileDetails/${id}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "Success") {
            setLandlordInfo(result.data);
          }
        })
        .catch((error) => console.error(error));
    },
    [loginSuccess?.token]
  );

  const GetLeaseDetails = useCallback(() => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/lease/getLeaseDetails/${recordId}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          GetTenantProfile(result.data.tenantInfo._id);
          GetLandlordProfile(result.data.landlordId);
          setLoading(false);
          setLeaseDetails(result.data);
        } else {
          ShowSuccess(result.message);
          setLoading(false);
        }
      })
      .catch((error) => console.error(error));
  }, [recordId, loginSuccess?.token, GetTenantProfile, GetLandlordProfile]);

  const [GetLeaseChat, setGetLeaseChat] = useState([]);

  const GetLeaseChatOnly = useCallback(() => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/lease/getLeaseChat/${recordId}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setGetLeaseChat(result.Conversation);
        } else {
        }
      })
      .catch((error) => console.error(error));
  }, [recordId, loginSuccess?.token]);

  const [lanlordInfo, setLandlordInfo] = useState();
  const [isSign, setIssign] = useState(false);

  useEffect(() => {
    GetLeaseDetails();
  }, [GetLeaseDetails]);

  useEffect(() => {
    if (recordId) {
      GetLeaseChatOnly();
    }
  }, [recordId, GetLeaseChatOnly]);

  useEffect(() => {
    let interval;

    if (recordId) {
      if (
        leaseDetails &&
        (leaseDetails?.status === "inActive" ||
          leaseDetails?.status === "rejected")
      ) {
        interval = setInterval(() => {
          GetLeaseChatOnly();
        }, 2000);
      }
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [recordId, GetLeaseChatOnly, leaseDetails]);

  const ChatUpdateHandler = (info) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      leaseId: leaseDetails?._id,
      sender: info.sender,
      text: info.text,
      senderType: info.senderType,
      time: info.time,
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/lease/updateLeaseConversation`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          GetLeaseChatOnly();
        }
      })
      .catch((error) => console.error(error));
  };
  const [loader, setLoader] = useState(false);

  const CheangeLeaseStatus = (status, sign) => {
    // Close the modal immediately before starting the transaction
    setIssign(false);
    // Start the loader after closing the modal
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      leaseId: leaseDetails?._id,
      status: status,
      tenanteSignature: sign ? sign : {},
      isTenantEsignature: sign ? true : false,
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/lease/changeLeaseStatus`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setLoader(false);
        if (result.status === 200) {
          ShowSuccess(result.message);
          // Refresh lease details and then navigate back
          GetLeaseDetails();
          setTimeout(() => {
            onBack();
          }, 1000);
        } else if (result.status === "error") {
          // Handle error response (e.g., payment failed)
          ShowError(result.message || "Failed to sign lease. Please try again.");
        } else {
          ShowError(result.message || "Oops! something went wrong");
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
        ShowError("Oops! something went wrong");
      });
  };
  const agreementRef = useRef();

  const generatePDF = () => {
    // Apply temporary styling fixes
    const applyTemporaryStyles = () => {
      const content = agreementRef.current;
      if (!content) return {};

      // Store original styles to restore later
      const originalStyles = new Map();

      // Save and set the root document container to full width for PDF
      originalStyles.set('root-container', {
        element: content,
        width: content.style.width,
        padding: content.style.padding,
      });
      
      // Set to full A4 width for PDF generation
      content.style.width = '190mm';
      content.style.padding = '15mm';

      // Find heading elements that might have border issues
      const headings = content.querySelectorAll("h1, h2, h3, .title, .heading");

      headings.forEach((heading, index) => {
        // Save original styles
        originalStyles.set(`heading-${index}`, {
          element: heading,
          padding: heading.style.padding,
          margin: heading.style.margin,
          lineHeight: heading.style.lineHeight,
          position: heading.style.position,
          zIndex: heading.style.zIndex,
        });

        // Apply temporary fixes
        heading.style.padding = "15px 0";
        heading.style.margin = "15px 0";
        heading.style.lineHeight = "1.5";
        heading.style.position = "relative";
        heading.style.zIndex = "2";
      });

      return originalStyles;
    };

    // Restore original styles after PDF generation
    const restoreStyles = (originalStyles) => {
      originalStyles.forEach((styles, key) => {
        const { element, padding, margin, lineHeight, position, zIndex, width } = styles;
        
        // Restore all saved properties
        if (width !== undefined) element.style.width = width;
        if (padding !== undefined) element.style.padding = padding;
        if (margin !== undefined) element.style.margin = margin;
        if (lineHeight !== undefined) element.style.lineHeight = lineHeight;
        if (position !== undefined) element.style.position = position;
        if (zIndex !== undefined) element.style.zIndex = zIndex;
      });
    };

    // Apply temporary styles and store original values
    const originalStyles = applyTemporaryStyles();

    // Generate PDF with improved settings
    html2canvas(agreementRef.current, {
      allowTaint: true,
      useCORS: true,
      scale: 2, // Higher scale for better quality
      logging: false,
      height: agreementRef.current.scrollHeight,
      width: agreementRef.current.scrollWidth,
      windowHeight: agreementRef.current.scrollHeight + 100,
      windowWidth: agreementRef.current.scrollWidth,
      imageTimeout: 15000,
      letterRendering: true,
      backgroundColor: "#FFFFFF",
      removeContainer: false,
      foreignObjectRendering: false,
    })
      .then((canvas) => {
        // Restore original styles immediately after canvas is generated
        restoreStyles(originalStyles);

        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
          compress: true,
        });

        const pageWidth = 210; // A4 page width in mm
        const pageHeight = 297; // A4 page height in mm
        const margin = 10; // Standard margins
        const contentWidth = pageWidth - 2 * margin; // 190mm (matches component width)
        const contentHeight = pageHeight - 2 * margin; // Available height per page

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        // Detect actual content height by finding the bottom-most non-white pixel
        let actualContentHeight = canvasHeight;
        const ctx = canvas.getContext('2d');
        const imageData = ctx.getImageData(0, 0, canvasWidth, canvasHeight);
        const data = imageData.data;
        
        // Scan from bottom to top to find where content ends
        for (let y = canvasHeight - 1; y >= 0; y--) {
          let hasContent = false;
          for (let x = 0; x < canvasWidth; x++) {
            const idx = (y * canvasWidth + x) * 4;
            // Check if pixel is not white (allowing for slight variations)
            if (data[idx] < 250 || data[idx + 1] < 250 || data[idx + 2] < 250) {
              hasContent = true;
              break;
            }
          }
          if (hasContent) {
            actualContentHeight = y + 1; // Add 1 to include this row
            break;
          }
        }

        // Calculate image dimensions maintaining aspect ratio
        // Use full content width (190mm) to fill the PDF page
        const imgWidth = contentWidth;
        // Use actual content height instead of full canvas height
        const imgHeight = (actualContentHeight * contentWidth) / canvasWidth;

        // Calculate how many pages we need
        const totalPages = Math.ceil(imgHeight / contentHeight);

        // Add content across multiple pages
        let yPosition = 0;

        for (let i = 0; i < totalPages; i++) {
          if (i > 0) {
            doc.addPage(); // Add a new page for subsequent pages
          }

          // Calculate the height for this page - use actual remaining content
          const remainingHeight = imgHeight - yPosition;
          const pageImgHeight = Math.min(remainingHeight, contentHeight);
          
          // Only proceed if there's actual content to add
          if (pageImgHeight <= 0) break;
          
          // Calculate the source Y position in pixels
          const sourceY = (yPosition / imgHeight) * canvasHeight;
          const sourceHeight = (pageImgHeight / imgHeight) * canvasHeight;

          // Create a temporary canvas for this page's portion
          const pageCanvas = document.createElement('canvas');
          pageCanvas.width = canvasWidth;
          pageCanvas.height = sourceHeight;
          const pageCtx = pageCanvas.getContext('2d');
          pageCtx.drawImage(
            canvas,
            0, sourceY, canvasWidth, sourceHeight, // Source rectangle
            0, 0, canvasWidth, sourceHeight // Destination rectangle
          );

          // Add the page image to PDF - only use the actual content height
          doc.addImage(
            pageCanvas.toDataURL("image/jpeg", 1.0),
            "JPEG",
            margin,
            margin,
            imgWidth,
            pageImgHeight
          );

          yPosition += pageImgHeight;
          
          // If we've added all content, break early
          if (yPosition >= imgHeight) break;
        }

        // Save the PDF
        doc.save("lease-agreement.pdf");
      })
      .catch((error) => {
        console.error("PDF generation error:", error);
        // Restore styles even if there's an error
        restoreStyles(originalStyles);
        alert("There was an error generating the PDF. Please try again.");
      });
  };

  const handleOnSubmit = (sign) => {
    CheangeLeaseStatus("active", sign);
    // LeaseDecisionHandler("active");
  };

  if (showTransactions) {
    return (
      <TransactionsTable
        onBack={() => setShowTransactions(false)}
        leaseId={leaseDetails?._id}
      />
    );
  }

  return (
    <div>
      <div className="mt-5 w-full parent">
        <Breadcrumbs
          classes={`text-darkColor font-popinsSemiBold text-xl`}
          content={`LE-${leaseDetails?._id?.slice(0, 10)}`}
          subheading="Lease Details"
          onBack={onBack}
        />

        {showDetailStatus === "active" ? (
          <div className="mb-5">
            {loading && <LeaseLoader />}
            {!loading && (
              <>
                <div className="flex h-full justify-between mt-5">
                  <div className="w-[64%]  rounded-lg h-full">
                    <div className="my-5">
                      {tenantInfo && <CompanyInfo data={tenantInfo} />}
                    </div>
                    <RentScheduleTable leaseDetails={leaseDetails} />
                    <div className="h-[400px] overflow-y-scroll panelScroll my-5 bg-white">
                      <Agreement
                        ref={agreementRef}
                        tenentInfo={leaseDetails?.tenantInfo}
                        data={leaseDetails}
                      />
                    </div>
                    <div className="h-[100px]">
                      <div className="bg-[#FAF2EC] flex px-5 h-full items-center rounded-lg">
                        <div className="w-[50%] flex items-center">
                          <ImageTag
                            path="/assets/daashboard/pdf.png"
                            classes="w-[50px] h-[45px]"
                            altText="logo"
                          />
                          <div className="pl-2">
                            <ParagraphTag
                              content="Signed Leases 2024.pdf"
                              classes="text-darkColor font-popinsSemiBold text-xs"
                            />
                            <ParagraphTag
                              content="Donec a eros justo. Fusce egestas tristique ultrices. Nam tempor, augue nec."
                              classes="text-darkColor font-popinsMedium text-[10px] line-clamp-2 pt-[2px]"
                            />
                            <div className="flex pt-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="13"
                                viewBox="0 0 12 13"
                                fill="none"
                              >
                                <path
                                  d="M3.20915 1.01507C3.20915 0.60703 3.54519 0.246997 3.97723 0.246997C4.38526 0.246997 4.7453 0.60703 4.7453 1.01507V1.78314H7.81758V1.01507C7.81758 0.60703 8.15362 0.246997 8.58566 0.246997C8.99369 0.246997 9.35373 0.60703 9.35373 1.01507V1.78314H10.5058C11.1299 1.78314 11.6579 2.31119 11.6579 2.93525V4.08736H0.90494V2.93525C0.90494 2.31119 1.40899 1.78314 2.05705 1.78314H3.20915V1.01507ZM11.6579 4.85543V11.384C11.6579 12.0321 11.1299 12.5361 10.5058 12.5361H2.05705C1.40899 12.5361 0.90494 12.0321 0.90494 11.384V4.85543H11.6579Z"
                                  fill="#FF814E"
                                />
                              </svg>
                              <ParagraphTag
                                content="10/09/2023"
                                classes="text-darkColor/40 font-popinsRegular text-xs pl-1"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-[50%] flex justify-end items-center">
                          <button
                            onClick={generatePDF}
                            className="border-2 border-themeColor flex justify-center items-center px-4 h-9 rounded-lg"
                          >
                            <ArrowBigDown color="#0381CA" size={20} />
                            <span className="text-themeColor font-popinsRegular text-xs pl-1">
                              Download Document
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[34%] h-full mt-5">
                    <div className="bg-white rounded-lg px-5">
                      <RentBreakDown leaseDetails={leaseDetails} />
                    </div>
                    <div className="mt-4">
                      <TenantInfo leaseDetails={lanlordInfo} />
                    </div>
                  </div>
                </div>

                <div className="flex justify-between mt-5">
                  <div className="w-full">
                    <PropertyInfo leaseDetails={leaseDetails} />
                  </div>
                </div>
                <div className="flex justify-between mt-5">
                  <div className="w-[49%]">
                    <MaintainRequestSection
                      recordId={recordId}
                      onViewDetails={onViewDetailsMaintain}
                      onMaintainanceTable={onMaintainancePage}
                    />
                  </div>
                  <div className="w-[49%]">
                    <ReceivePayment
                      leaseDetails={leaseDetails}
                      handleTenantTable={toggleTennatTable}
                      onViewAllTransactions={(leaseId) => {
                        setShowTransactions(true);
                      }}
                    />
                  </div>
                </div>
                <div className="flex flex-wrap mt-5" id="gk-cards">
                  {/* {lease.cardData2.map((item, i) => (
                    <InfoCards
                      item={item}
                      leaseDetails={leaseDetails}
                      onTrigger={onTriggerCard}
                    />
                  ))} */}
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="h-screen">
            {loading && <LeaseLoader />}
            {!loading && (
              <div className="flex justify-between h-full">
                <div className="w-[59%] h-screen overflow-scroll scrollbar-hide panelScroll py-5">
                  {tenantInfo && <LandlordInfo data={tenantInfo} />}

                  <div className="mt-5">
                    {tenantInfo && <CompanyInfo data={tenantInfo} />}
                  </div>
                  {leaseDetails.status === "terminated" && (
                    <div className="mt-5">
                      <TerminationReason
                        reason={leaseDetails.terminationReason}
                        amount={leaseDetails.refundAmount}
                        data={tenantInfo}
                        leaseId={leaseDetails._id}
                        onViewAllTransactions={(leaseId) => {
                          setShowTransactions(true);
                        }}
                      />
                    </div>
                  )}
                  {leaseDetails.status === "completed" && (
                    <div className="mt-5">
                      <div className="bg-white rounded-xl p-2">
                        <div className="px-4 pt-4">
                          <ParagraphTag
                            content="Lease Completed"
                            classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
                          />
                          <ParagraphTag
                            content="Your lease has been successfully completed. Thank you for being a valued tenant. All lease obligations have been fulfilled and your tenancy has officially ended."
                            classes="text-gray-600 font-popinsRegular text-sm leading-relaxed"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="mt-5">
                    <PropertyInfo leaseDetails={leaseDetails} />
                  </div>
                  <div className="mt-5">
                    <RentScheduleTable leaseDetails={leaseDetails} />
                  </div>
                  <div className="mt-5 bg-white rounded-lg">
                    <div className="h-[400px] overflow-y-scroll panelScroll mb-5">
                      <Agreement
                        ref={agreementRef}
                        tenentInfo={leaseDetails?.tenantInfo}
                        data={leaseDetails}
                      />
                    </div>
                    <div className="h-[100px]">
                      <div className="bg-[#FAF2EC] flex px-5 h-full items-center rounded-lg">
                        <div className="w-[50%] flex items-center">
                          <ImageTag
                            path="/assets/daashboard/pdf.png"
                            classes="w-[50px] h-[45px]"
                            altText="logo"
                          />
                          <div className="pl-2">
                            <ParagraphTag
                              content="Signed Leases 2024.pdf"
                              classes="text-darkColor font-popinsSemiBold text-xs"
                            />
                            <ParagraphTag
                              content="Donec a eros justo. Fusce egestas tristique ultrices. Nam tempor, augue nec."
                              classes="text-darkColor font-popinsMedium text-[10px] line-clamp-2 pt-[2px]"
                            />
                            <div className="flex pt-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="13"
                                viewBox="0 0 12 13"
                                fill="none"
                              >
                                <path
                                  d="M3.20915 1.01507C3.20915 0.60703 3.54519 0.246997 3.97723 0.246997C4.38526 0.246997 4.7453 0.60703 4.7453 1.01507V1.78314H7.81758V1.01507C7.81758 0.60703 8.15362 0.246997 8.58566 0.246997C8.99369 0.246997 9.35373 0.60703 9.35373 1.01507V1.78314H10.5058C11.1299 1.78314 11.6579 2.31119 11.6579 2.93525V4.08736H0.90494V2.93525C0.90494 2.31119 1.40899 1.78314 2.05705 1.78314H3.20915V1.01507ZM11.6579 4.85543V11.384C11.6579 12.0321 11.1299 12.5361 10.5058 12.5361H2.05705C1.40899 12.5361 0.90494 12.0321 0.90494 11.384V4.85543H11.6579Z"
                                  fill="#FF814E"
                                />
                              </svg>
                              <ParagraphTag
                                content="10/09/2023"
                                classes="text-darkColor/40 font-popinsRegular text-xs pl-1"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-[50%] flex justify-end items-center">
                          <button
                            onClick={generatePDF}
                            className="border-2 border-themeColor flex justify-center items-center px-4 h-9 rounded-lg"
                          >
                            <ArrowBigDown color="#0381CA" size={20} />
                            <span className="text-themeColor font-popinsRegular text-xs pl-1">
                              Download Document
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg mt-5">
                    <RentBreakDown leaseDetails={leaseDetails} />
                  </div>

                  {/* Action buttons based on lease status */}
                  {leaseDetails?.status === "terminated" ? (
                    <div className="pt-4">
                      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded text-center">
                        <ParagraphTag
                          content="This lease has been terminated"
                          classes="text-red-700 font-popinsSemiBold text-sm"
                        />
                      </div>
                    </div>
                  ) : leaseDetails?.status === "completed" ? (
                    <div className="pt-4">
                      <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded text-center">
                        <ParagraphTag
                          content="This lease has been completed"
                          classes="text-green-700 font-popinsSemiBold text-sm"
                        />
                      </div>
                    </div>
                  ) : leaseDetails?.status === "active" ? (
                    <div className="pt-4">
                      <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded text-center">
                        <ParagraphTag
                          content="Lease is active and signed"
                          classes="text-green-700 font-popinsSemiBold text-sm"
                        />
                      </div>
                    </div>
                  ) : leaseDetails?.status === "rejected" ? (
                    <div className="pt-4">
                      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded text-center">
                        <ParagraphTag
                          content="This lease has been rejected"
                          classes="text-red-700 font-popinsSemiBold text-sm"
                        />
                      </div>
                    </div>
                  ) : (
                    // Show Sign/Reject buttons only for pending/inActive leases
                    <div className="pt-4">
                      {loader ? (
                        <div className="flex w-full justify-center items-center mt-2">
                          <Myloader />
                        </div>
                      ) : (
                        <div className="flex justify-between">
                          <div className="w-[49%]">
                            <ButtonTag
                              onSubmit={(e) => {
                                e.preventDefault();
                                CheangeLeaseStatus("rejected");
                              }}
                              name="Reject"
                              classes="text-sm text-center bg-red-500 text-white hover:bg-red-600"
                            />
                          </div>
                          <div className="w-[49%]">
                            <ButtonTag
                              onSubmit={() => {
                                setIssign(true);
                              }}
                              name="Sign Lease"
                              classes="text-sm text-center bg-themeColor text-white hover:bg-blue-600"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="w-[39%] pt-5 h-full">
                  <Chat
                    termiinated={
                      showDetailStatus === "terminated" ? true : false
                    }
                    chatUpdateHandler={ChatUpdateHandler}
                    leaseDetailsChat={GetLeaseChat}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {isSign && (
        <SignPopup
          onSubmit={(sign) => {
            handleOnSubmit(sign);
          }}
          onClose={() => {
            setIssign(false);
          }}
        />
      )}
    </div>
  );
};

export default DetailLeaseMain;
